import enLocale from 'vee-validate/dist/locale/en.json';

const en = {
  welcomeMessage: 'Welcome aboard',
  home: 'Home',
  error: 'Error',
  success: 'success',
  nationalUnifiedNumber: 'National Unified Number',
  serverErrors: {
    USER_NOT_FOUND: 'User is not found, please try again',
  },
  fields: {
    email: 'E-mail',
    mobile: 'Mobile',
  },
  validation: {
    ...enLocale.messages,
    mobile: 'Sorry, the {_field_} entered is incorrect. It must start with (05) and not exceed 10 numbers',
  },
};

export default en;
